import { render, staticRenderFns } from "./GhanaThinkTank.vue?vue&type=template&id=9bf02e26&scoped=true"
import script from "./GhanaThinkTank.vue?vue&type=script&lang=js"
export * from "./GhanaThinkTank.vue?vue&type=script&lang=js"
import style0 from "./GhanaThinkTank.vue?vue&type=style&index=0&id=9bf02e26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bf02e26",
  null
  
)

export default component.exports